// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Config editor */
.config-page {
  display: grid;
  grid-template-rows: 36px auto 1fr;
  height: 100vh;
  overflow: hidden;
}
.config-toolbar {
  display: flex; align-items: center; gap: 8px;
  border-bottom: 1px solid var(--rule);
  background: var(--bg-elev);
  padding: 0 12px;
  height: 44px;
}
.config-toolbar .picker {
  display: flex; align-items: center; gap: 8px;
  padding: 4px 12px; height: 32px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  background: var(--bg);
  cursor: pointer;
}
.config-toolbar .picker .lbl {
  font-size: 9.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);
}
.config-toolbar .picker .val {
  font-family: var(--mono); font-size: 12.5px; font-weight: 600; color: var(--ink);
  font-feature-settings: 'tnum';
}
.config-toolbar .picker .val .meta {
  font-family: var(--sans); font-weight: 400; color: var(--ink-3); font-size: 11.5px; margin-left: 6px;
}
.config-toolbar .meta-strip {
  margin-left: 16px;
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
  display: flex; gap: 14px;
}
.config-toolbar .meta-strip b { color: var(--ink); font-weight: 500; }
.config-toolbar .actions {
  margin-left: auto; display: flex; gap: 4px;
}
.config-toolbar .actions button {
  padding: 6px 12px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  font-size: 11.5px; color: var(--ink-2);
  background: var(--bg);
}
.config-toolbar .actions button.primary {
  border-color: var(--accent); color: var(--accent);
  background: color-mix(in oklab, var(--accent) 8%, var(--bg));
}
.config-toolbar .actions button:hover { background: var(--bg-sunk); }

.config-body {
  display: grid;
  grid-template-columns: 360px 1fr 360px;
  height: 100%;
  overflow: hidden;
}

/* ─── Left pane: tree ─── */
.tree-pane {
  border-right: 1px solid var(--rule);
  background: var(--bg-elev);
  overflow: auto;
  display: flex; flex-direction: column;
}
.tree-pane .ph {
  position: sticky; top: 0;
  display: flex; align-items: center;
  padding: 10px 14px;
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule);
  z-index: 2;
}
.tree-pane .ph .t {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3); font-weight: 600;
}
.tree-pane .ph .add {
  margin-left: auto;
  font-size: 11px; color: var(--accent);
  border: 1px solid var(--rule);
  border-radius: 3px;
  padding: 3px 8px;
  background: var(--bg);
}
.tree-pane .search-row {
  padding: 6px 10px;
  border-bottom: 1px solid var(--rule-soft);
  background: var(--bg);
}
.tree-pane .search-row input {
  width: 100%;
  padding: 5px 8px;
  background: transparent;
  border: 1px solid var(--rule);
  border-radius: 3px;
  font-size: 11.5px; color: var(--ink);
  outline: 0;
}
.tree-pane .search-row input:focus { border-color: var(--accent); }
.tree-section {
  padding: 10px 14px 4px;
  display: flex; align-items: baseline; gap: 8px;
  background: var(--bg-elev);
  border-top: 1px solid var(--rule-soft);
}
.tree-section:first-child { border-top: 0; }
.tree-section .num {
  font-family: var(--mono); font-size: 10px; color: var(--ink-4);
  font-feature-settings: 'tnum';
}
.tree-section .name {
  font-size: 11.5px; font-weight: 600; color: var(--ink);
  text-transform: uppercase; letter-spacing: .04em;
}
.tree-section .ct {
  margin-left: auto;
  font-family: var(--mono); font-size: 10px; color: var(--ink-4);
  font-feature-settings: 'tnum';
}
.tree-node {
  display: flex; align-items: center; gap: 8px;
  height: 28px;
  padding: 0 14px;
  font-size: 12px;
  color: var(--ink-2);
  cursor: pointer;
  border-left: 2px solid transparent;
}
.tree-node:hover { background: var(--bg-sunk); }
.tree-node.selected {
  background: var(--bg);
  border-left-color: var(--accent);
  color: var(--ink);
}
.tree-node .ind { width: 14px; flex: 0 0 14px; color: var(--ink-4); font-family: var(--mono); font-size: 11px; }
.tree-node .name { flex: 1 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tree-node.total .name { font-weight: 500; color: var(--ink); }
.tree-node .meta {
  font-family: var(--mono); font-size: 10px; color: var(--ink-4);
  font-feature-settings: 'tnum';
}
.tree-node .iss {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--diff);
}

/* ─── Center pane: editor ─── */
.editor-pane {
  overflow: auto;
  background: var(--bg);
  padding: 22px 28px 80px;
}
.editor-pane h1 {
  font-size: 19px; font-weight: 600; color: var(--ink);
  margin: 0 0 4px;
  letter-spacing: -.005em;
}
.editor-pane .breadcrumb {
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  margin-bottom: 22px;
  font-feature-settings: 'tnum';
}
.editor-pane .breadcrumb .sep { color: var(--ink-4); margin: 0 6px; }
.editor-pane .row-meta {
  display: flex; gap: 24px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--rule);
}
.editor-pane .row-meta .field {
  display: flex; flex-direction: column; gap: 4px;
}
.editor-pane .row-meta .lbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);
}
.editor-pane .row-meta .v {
  font-family: var(--mono); font-size: 12.5px; font-feature-settings: 'tnum';
  color: var(--ink);
}
.editor-pane .row-meta .v.sans {
  font-family: var(--sans);
}
.editor-pane h3 {
  font-size: 11px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3); font-weight: 600;
  margin: 24px 0 8px;
}

/* formula builder */
.formula-builder {
  border: 1px solid var(--rule);
  border-radius: 3px;
  background: var(--bg-elev);
}
.formula-builder .formula-line {
  font-family: var(--mono); font-size: 13.5px; line-height: 1.6;
  color: var(--ink);
  padding: 14px 16px;
  background: var(--bg);
  border-radius: 2px 2px 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.formula-builder .formula-line .tok {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 3px 8px;
  border: 1px solid var(--rule);
  background: var(--bg-elev);
  border-radius: 3px;
  font-feature-settings: 'tnum';
}
.formula-builder .formula-line .tok .file {
  color: var(--accent); font-weight: 500;
}
.formula-builder .formula-line .tok .cell { color: var(--ink); }
.formula-builder .formula-line .tok .preview {
  color: var(--ink-3); font-size: 11px; margin-left: 4px;
  padding-left: 8px; border-left: 1px solid var(--rule-soft);
}
.formula-builder .formula-line .op {
  color: var(--ink-3); font-size: 14px; font-weight: 600;
}
.formula-builder .formula-line .add-tok {
  border: 1px dashed var(--ink-4);
  color: var(--ink-4);
  font-size: 11px;
  background: transparent;
  cursor: pointer;
}
.formula-builder .formula-line .add-tok:hover { color: var(--accent); border-color: var(--accent); }
.formula-builder .formula-foot {
  display: flex; align-items: center; gap: 12px;
  padding: 8px 14px;
  border-top: 1px solid var(--rule);
  background: var(--bg-elev);
  font-size: 11px;
  color: var(--ink-3);
  font-family: var(--mono);
  font-feature-settings: 'tnum';
}
.formula-builder .formula-foot .btn {
  padding: 4px 10px;
  border: 1px solid var(--rule);
  border-radius: 3px;
  background: var(--bg);
  color: var(--ink-2);
  font-family: var(--sans);
  font-size: 11px;
  cursor: pointer;
}
.formula-builder .formula-foot .btn:hover { background: var(--bg-sunk); }
.formula-builder .formula-foot .res { margin-left: auto; }
.formula-builder .formula-foot .res b {
  color: var(--ink); font-weight: 500;
  font-size: 12px;
}

/* sources table */
.src-table {
  border: 1px solid var(--rule);
  border-radius: 3px;
  overflow: hidden;
}
.src-table .h, .src-table .r {
  display: grid;
  grid-template-columns: 28px 90px 70px 1fr 130px 30px;
  align-items: center;
  height: 32px;
}
.src-table .h {
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule);
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3);
}
.src-table .h > div, .src-table .r > div {
  padding: 0 10px; height: 100%; display: flex; align-items: center;
  border-right: 1px solid var(--rule-soft);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.src-table .h > div:last-child, .src-table .r > div:last-child { border-right: 0; }
.src-table .h .n, .src-table .r .n { justify-content: flex-end; }
.src-table .r {
  border-bottom: 1px solid var(--rule-soft);
  font-size: 12px;
}
.src-table .r:last-child { border-bottom: 0; }
.src-table .r:hover { background: var(--bg-sunk); }
.src-table .r .file {
  font-family: var(--mono); font-size: 11.5px; color: var(--accent); font-weight: 500;
  font-feature-settings: 'tnum';
}
.src-table .r .cell {
  font-family: var(--mono); font-size: 11.5px; color: var(--ink);
}
.src-table .r .label { color: var(--ink-2); }
.src-table .r .v { font-family: var(--mono); color: var(--ink); font-feature-settings: 'tnum'; }
.src-table .r .x { color: var(--ink-4); cursor: pointer; }
.src-table .r .x:hover { color: var(--diff); }
.src-table .add-row {
  display: flex; align-items: center; justify-content: center;
  height: 30px;
  border-top: 1px dashed var(--rule);
  background: var(--bg-elev);
  color: var(--ink-3); font-size: 11px;
  cursor: pointer;
}
.src-table .add-row:hover { color: var(--accent); }

/* master mapping */
.master-map {
  border: 1px solid var(--rule);
  border-left: 3px solid var(--accent);
  border-radius: 3px;
  padding: 12px 14px;
  background: var(--bg-elev);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
}
.master-map .field {
  display: flex; flex-direction: column; gap: 4px;
}
.master-map .lbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);
}
.master-map .v {
  font-family: var(--mono); font-size: 12.5px; color: var(--ink);
  font-feature-settings: 'tnum';
}

/* validation */
.valid-list {
  display: flex; flex-direction: column;
  gap: 1px;
  background: var(--rule-soft);
  border: 1px solid var(--rule);
  border-radius: 3px;
}
.valid-rule {
  display: flex; align-items: center; gap: 12px;
  padding: 8px 12px;
  background: var(--bg);
  font-size: 11.5px;
}
.valid-rule .dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: var(--match);
  flex: 0 0 8px;
}
.valid-rule.bad .dot { background: var(--diff); }
.valid-rule .lbl { color: var(--ink); flex: 0 0 auto; }
.valid-rule .msg {
  margin-left: auto;
  font-family: var(--mono); font-size: 11px; color: var(--ink-3);
  font-feature-settings: 'tnum';
}
.valid-rule.bad .msg { color: var(--diff); }

/* ─── Right pane: live preview ─── */
.preview-pane {
  border-left: 1px solid var(--rule);
  background: var(--bg-elev);
  overflow: auto;
  display: flex; flex-direction: column;
}
.preview-pane .ph {
  position: sticky; top: 0;
  display: flex; align-items: baseline;
  padding: 10px 14px;
  background: var(--bg-elev);
  border-bottom: 1px solid var(--rule);
  z-index: 2;
}
.preview-pane .ph .t {
  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-3); font-weight: 600;
}
.preview-pane .ph .live {
  margin-left: auto;
  font-family: var(--mono); font-size: 10px; color: var(--match);
  font-feature-settings: 'tnum';
}
.preview-pane .ph .live .dot {
  display: inline-block; width: 6px; height: 6px; border-radius: 50%;
  background: var(--match); margin-right: 4px;
  vertical-align: middle;
  animation: pulse 2s ease-in-out infinite;
}
@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .35; } }

.preview-pane .pr-block {
  padding: 14px 14px;
  border-bottom: 1px solid var(--rule-soft);
}
.preview-pane .pr-block .h {
  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;
  color: var(--ink-4); font-weight: 600;
  margin-bottom: 6px;
}
.preview-pane .pr-cluster {
  display: grid; grid-template-columns: 60px 1fr auto;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid var(--rule-soft);
  gap: 8px;
}
.preview-pane .pr-cluster:last-child { border-bottom: 0; }
.preview-pane .pr-cluster .code {
  font-family: var(--mono); font-size: 11px; font-weight: 600;
  color: var(--ink); letter-spacing: .04em;
}
.preview-pane .pr-cluster .name {
  font-size: 11.5px; color: var(--ink-2);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.preview-pane .pr-cluster .v {
  font-family: var(--mono); font-size: 12px;
  color: var(--ink); font-feature-settings: 'tnum';
}
.preview-pane .pr-cluster.curr {
  background: color-mix(in oklab, var(--accent) 6%, transparent);
}

.preview-pane .impact {
  font-size: 11.5px; color: var(--ink-2);
  line-height: 1.5;
}
.preview-pane .impact b { color: var(--ink); font-weight: 500; }

/* ─── Cell preview popover ─── */
.cell-pop {
  position: fixed;
  z-index: 200;
  width: 380px;
  background: var(--bg-elev);
  border: 1px solid var(--rule);
  border-radius: 4px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, .14), 0 2px 8px rgba(0, 0, 0, .08);
  font-family: var(--mono);
  font-size: 11px;
  pointer-events: none;
  animation: cpFade .12s ease-out;
}
@keyframes cpFade {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}
.cell-pop .cph {
  display: flex; align-items: baseline; gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--rule);
  background: var(--bg);
  border-radius: 4px 4px 0 0;
  font-feature-settings: 'tnum';
}
.cell-pop .cph .ftag {
  color: var(--accent); font-weight: 600;
  font-size: 11px;
}
.cell-pop .cph .sheet {
  color: var(--ink-4); font-size: 10.5px;
}
.cell-pop .cph .cell {
  margin-left: 4px;
  color: var(--ink); font-weight: 500;
  padding: 1px 5px;
  background: color-mix(in oklab, var(--accent) 12%, transparent);
  border-radius: 2px;
  font-size: 11px;
}
.cell-pop .cph .lbl {
  margin-left: auto;
  color: var(--ink-3);
  font-family: var(--sans);
  font-size: 10.5px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.cell-pop .cgrid {
  width: 100%;
  border-collapse: collapse;
  font-feature-settings: 'tnum';
}
.cell-pop .cgrid td {
  padding: 4px 8px;
  border-right: 1px solid var(--rule-soft);
  border-bottom: 1px solid var(--rule-soft);
  font-size: 10.5px;
  color: var(--ink-2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}
.cell-pop .cgrid td:last-child { border-right: 0; }
.cell-pop .cgrid tr:last-child td { border-bottom: 0; }
.cell-pop .cgrid tr.h td {
  background: var(--bg);
  color: var(--ink-4);
  font-size: 10px;
  font-weight: 500;
  text-transform: none;
}
.cell-pop .cgrid td.rh {
  background: var(--bg);
  color: var(--ink-4);
  font-size: 10px;
  text-align: right;
  width: 30px;
}
.cell-pop .cgrid td.n { text-align: right; }
.cell-pop .cgrid td.hl {
  background: color-mix(in oklab, var(--accent) 14%, var(--bg-elev));
  color: var(--ink);
  font-weight: 600;
  outline: 1px solid var(--accent);
  outline-offset: -1px;
  position: relative; z-index: 1;
}
.cell-pop .cpf {
  padding: 7px 12px;
  border-top: 1px solid var(--rule);
  font-size: 10.5px;
  color: var(--ink-3);
  font-family: var(--sans);
  background: var(--bg);
  border-radius: 0 0 4px 4px;
}

/* ref token (formula referring to another row) */
.formula-builder .formula-line .tok.ref .file {
  color: var(--ink-3);
  font-style: italic;
}
.formula-builder .formula-line .tok.ref {
  background: var(--bg);
}
`, "",{"version":3,"sources":["webpack://./src/v2/config.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,YAAY;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;AACzF;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB;EAChF,6BAA6B;AAC/B;AACA;EACE,wBAAwB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB;AACtG;AACA;EACE,iBAAiB;EACjB,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;EAC7B,aAAa,EAAE,SAAS;AAC1B;AACA,gCAAgC,iBAAiB,EAAE,gBAAgB,EAAE;AACrE;EACE,iBAAiB,EAAE,aAAa,EAAE,QAAQ;AAC5C;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB,EAAE,mBAAmB;EACtC,qBAAqB;AACvB;AACA;EACE,2BAA2B,EAAE,oBAAoB;EACjD,4DAA4D;AAC9D;AACA,wCAAwC,0BAA0B,EAAE;;AAEpE;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,cAAc;EACd,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,gBAAgB,EAAE,MAAM;EACxB,aAAa,EAAE,mBAAmB;EAClC,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB;EACnE,mBAAmB,EAAE,gBAAgB;AACvC;AACA;EACE,iBAAiB;EACjB,eAAe,EAAE,oBAAoB;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB,EAAE,iBAAiB;EACpC,UAAU;AACZ;AACA,qCAAqC,2BAA2B,EAAE;AAClE;EACE,sBAAsB;EACtB,aAAa,EAAE,qBAAqB,EAAE,QAAQ;EAC9C,0BAA0B;EAC1B,sCAAsC;AACxC;AACA,4BAA4B,aAAa,EAAE;AAC3C;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB;EACtD,yBAAyB,EAAE,qBAAqB;AAClD;AACA;EACE,iBAAiB;EACjB,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;AACA,mBAAmB,0BAA0B,EAAE;AAC/C;EACE,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;AACnB;AACA,kBAAkB,WAAW,EAAE,cAAc,EAAE,mBAAmB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AAC/G,mBAAmB,SAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5F,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE;AAC9D;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB;EACpD,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,mBAAmB;EACnB,6BAA6B;AAC/B;AACA,gCAAgC,mBAAmB,EAAE,aAAa,EAAE;AACpE;EACE,aAAa,EAAE,SAAS;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;AACxF;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B;EAC1E,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB;EACjE,mBAAmB,EAAE,gBAAgB;EACrC,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB;EAC7D,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,oBAAoB,EAAE,gBAAgB;AACxC;AACA,4CAA4C,iBAAiB,EAAE;AAC/D;EACE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;EACtD,iBAAiB,EAAE,uCAAuC;AAC5D;AACA;EACE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;AACxD;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;AACA,gDAAgD,oBAAoB,EAAE,2BAA2B,EAAE;AACnG;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,iBAAiB;EACjB,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;AACA,4CAA4C,0BAA0B,EAAE;AACxE,sCAAsC,iBAAiB,EAAE;AACzD;EACE,iBAAiB,EAAE,gBAAgB;EACnC,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,eAAe,EAAE,yBAAyB,EAAE,qBAAqB;EACjE,mBAAmB;AACrB;AACA;EACE,eAAe,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EACjE,wCAAwC;EACxC,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA,iEAAiE,eAAe,EAAE;AAClF,qCAAqC,yBAAyB,EAAE;AAChE;EACE,yCAAyC;EACzC,eAAe;AACjB;AACA,2BAA2B,gBAAgB,EAAE;AAC7C,sBAAsB,0BAA0B,EAAE;AAClD;EACE,wBAAwB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB;EACnF,6BAA6B;AAC/B;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,iBAAiB;AAChE;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,mBAAmB,wBAAwB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AAC/F,mBAAmB,mBAAmB,EAAE,eAAe,EAAE;AACzD,yBAAyB,kBAAkB,EAAE;AAC7C;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB,EAAE,eAAe;EACpC,eAAe;AACjB;AACA,4BAA4B,oBAAoB,EAAE;;AAElD,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;AACA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB;AACxF;AACA;EACE,wBAAwB,EAAE,iBAAiB,EAAE,iBAAiB;EAC9D,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa,EAAE,sBAAsB;EACrC,QAAQ;EACR,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,wBAAwB;EACxB,aAAa;AACf;AACA,uBAAuB,uBAAuB,EAAE;AAChD,mBAAmB,iBAAiB,EAAE,cAAc,EAAE;AACtD;EACE,iBAAiB;EACjB,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA,uBAAuB,kBAAkB,EAAE;;AAE3C,qCAAqC;AACrC;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,aAAa,EAAE,sBAAsB;AACvC;AACA;EACE,gBAAgB,EAAE,MAAM;EACxB,aAAa,EAAE,qBAAqB;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB;EACnE,mBAAmB,EAAE,gBAAgB;AACvC;AACA;EACE,iBAAiB;EACjB,wBAAwB,EAAE,eAAe,EAAE,mBAAmB;EAC9D,6BAA6B;AAC/B;AACA;EACE,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAClE,wBAAwB,EAAE,iBAAiB;EAC3C,sBAAsB;EACtB,wCAAwC;AAC1C;AACA,mBAAmB,WAAW,UAAU,EAAE,EAAE,MAAM,YAAY,EAAE,EAAE;;AAElE;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB;EACjE,mBAAmB,EAAE,gBAAgB;EACrC,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,oCAAoC;EACnD,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,QAAQ;AACV;AACA,uCAAuC,gBAAgB,EAAE;AACzD;EACE,wBAAwB,EAAE,eAAe,EAAE,gBAAgB;EAC3D,iBAAiB,EAAE,qBAAqB;AAC1C;AACA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,wBAAwB,EAAE,eAAe;EACzC,iBAAiB,EAAE,6BAA6B;AAClD;AACA;EACE,8DAA8D;AAChE;;AAEA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,gBAAgB;AAClB;AACA,0BAA0B,iBAAiB,EAAE,gBAAgB,EAAE;;AAE/D,iCAAiC;AACjC;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,wEAAwE;EACxE,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,aAAa,EAAE,qBAAqB,EAAE,QAAQ;EAC9C,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,oBAAoB,EAAE,gBAAgB;EACtC,eAAe;AACjB;AACA;EACE,mBAAmB,EAAE,iBAAiB;AACxC;AACA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,gBAAgB;EACnC,gBAAgB;EAChB,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,iCAAiC,eAAe,EAAE;AAClD,oCAAoC,gBAAgB,EAAE;AACtD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA,wBAAwB,iBAAiB,EAAE;AAC3C;EACE,kEAAkE;EAClE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB,EAAE,UAAU;AAChC;AACA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/* Config editor */\n.config-page {\n  display: grid;\n  grid-template-rows: 36px auto 1fr;\n  height: 100vh;\n  overflow: hidden;\n}\n.config-toolbar {\n  display: flex; align-items: center; gap: 8px;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg-elev);\n  padding: 0 12px;\n  height: 44px;\n}\n.config-toolbar .picker {\n  display: flex; align-items: center; gap: 8px;\n  padding: 4px 12px; height: 32px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  background: var(--bg);\n  cursor: pointer;\n}\n.config-toolbar .picker .lbl {\n  font-size: 9.5px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);\n}\n.config-toolbar .picker .val {\n  font-family: var(--mono); font-size: 12.5px; font-weight: 600; color: var(--ink);\n  font-feature-settings: 'tnum';\n}\n.config-toolbar .picker .val .meta {\n  font-family: var(--sans); font-weight: 400; color: var(--ink-3); font-size: 11.5px; margin-left: 6px;\n}\n.config-toolbar .meta-strip {\n  margin-left: 16px;\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n  display: flex; gap: 14px;\n}\n.config-toolbar .meta-strip b { color: var(--ink); font-weight: 500; }\n.config-toolbar .actions {\n  margin-left: auto; display: flex; gap: 4px;\n}\n.config-toolbar .actions button {\n  padding: 6px 12px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  font-size: 11.5px; color: var(--ink-2);\n  background: var(--bg);\n}\n.config-toolbar .actions button.primary {\n  border-color: var(--accent); color: var(--accent);\n  background: color-mix(in oklab, var(--accent) 8%, var(--bg));\n}\n.config-toolbar .actions button:hover { background: var(--bg-sunk); }\n\n.config-body {\n  display: grid;\n  grid-template-columns: 360px 1fr 360px;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* ─── Left pane: tree ─── */\n.tree-pane {\n  border-right: 1px solid var(--rule);\n  background: var(--bg-elev);\n  overflow: auto;\n  display: flex; flex-direction: column;\n}\n.tree-pane .ph {\n  position: sticky; top: 0;\n  display: flex; align-items: center;\n  padding: 10px 14px;\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule);\n  z-index: 2;\n}\n.tree-pane .ph .t {\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3); font-weight: 600;\n}\n.tree-pane .ph .add {\n  margin-left: auto;\n  font-size: 11px; color: var(--accent);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  padding: 3px 8px;\n  background: var(--bg);\n}\n.tree-pane .search-row {\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--rule-soft);\n  background: var(--bg);\n}\n.tree-pane .search-row input {\n  width: 100%;\n  padding: 5px 8px;\n  background: transparent;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  font-size: 11.5px; color: var(--ink);\n  outline: 0;\n}\n.tree-pane .search-row input:focus { border-color: var(--accent); }\n.tree-section {\n  padding: 10px 14px 4px;\n  display: flex; align-items: baseline; gap: 8px;\n  background: var(--bg-elev);\n  border-top: 1px solid var(--rule-soft);\n}\n.tree-section:first-child { border-top: 0; }\n.tree-section .num {\n  font-family: var(--mono); font-size: 10px; color: var(--ink-4);\n  font-feature-settings: 'tnum';\n}\n.tree-section .name {\n  font-size: 11.5px; font-weight: 600; color: var(--ink);\n  text-transform: uppercase; letter-spacing: .04em;\n}\n.tree-section .ct {\n  margin-left: auto;\n  font-family: var(--mono); font-size: 10px; color: var(--ink-4);\n  font-feature-settings: 'tnum';\n}\n.tree-node {\n  display: flex; align-items: center; gap: 8px;\n  height: 28px;\n  padding: 0 14px;\n  font-size: 12px;\n  color: var(--ink-2);\n  cursor: pointer;\n  border-left: 2px solid transparent;\n}\n.tree-node:hover { background: var(--bg-sunk); }\n.tree-node.selected {\n  background: var(--bg);\n  border-left-color: var(--accent);\n  color: var(--ink);\n}\n.tree-node .ind { width: 14px; flex: 0 0 14px; color: var(--ink-4); font-family: var(--mono); font-size: 11px; }\n.tree-node .name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.tree-node.total .name { font-weight: 500; color: var(--ink); }\n.tree-node .meta {\n  font-family: var(--mono); font-size: 10px; color: var(--ink-4);\n  font-feature-settings: 'tnum';\n}\n.tree-node .iss {\n  width: 6px; height: 6px; border-radius: 50%;\n  background: var(--diff);\n}\n\n/* ─── Center pane: editor ─── */\n.editor-pane {\n  overflow: auto;\n  background: var(--bg);\n  padding: 22px 28px 80px;\n}\n.editor-pane h1 {\n  font-size: 19px; font-weight: 600; color: var(--ink);\n  margin: 0 0 4px;\n  letter-spacing: -.005em;\n}\n.editor-pane .breadcrumb {\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  margin-bottom: 22px;\n  font-feature-settings: 'tnum';\n}\n.editor-pane .breadcrumb .sep { color: var(--ink-4); margin: 0 6px; }\n.editor-pane .row-meta {\n  display: flex; gap: 24px;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--rule);\n}\n.editor-pane .row-meta .field {\n  display: flex; flex-direction: column; gap: 4px;\n}\n.editor-pane .row-meta .lbl {\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);\n}\n.editor-pane .row-meta .v {\n  font-family: var(--mono); font-size: 12.5px; font-feature-settings: 'tnum';\n  color: var(--ink);\n}\n.editor-pane .row-meta .v.sans {\n  font-family: var(--sans);\n}\n.editor-pane h3 {\n  font-size: 11px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3); font-weight: 600;\n  margin: 24px 0 8px;\n}\n\n/* formula builder */\n.formula-builder {\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  background: var(--bg-elev);\n}\n.formula-builder .formula-line {\n  font-family: var(--mono); font-size: 13.5px; line-height: 1.6;\n  color: var(--ink);\n  padding: 14px 16px;\n  background: var(--bg);\n  border-radius: 2px 2px 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n.formula-builder .formula-line .tok {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 3px 8px;\n  border: 1px solid var(--rule);\n  background: var(--bg-elev);\n  border-radius: 3px;\n  font-feature-settings: 'tnum';\n}\n.formula-builder .formula-line .tok .file {\n  color: var(--accent); font-weight: 500;\n}\n.formula-builder .formula-line .tok .cell { color: var(--ink); }\n.formula-builder .formula-line .tok .preview {\n  color: var(--ink-3); font-size: 11px; margin-left: 4px;\n  padding-left: 8px; border-left: 1px solid var(--rule-soft);\n}\n.formula-builder .formula-line .op {\n  color: var(--ink-3); font-size: 14px; font-weight: 600;\n}\n.formula-builder .formula-line .add-tok {\n  border: 1px dashed var(--ink-4);\n  color: var(--ink-4);\n  font-size: 11px;\n  background: transparent;\n  cursor: pointer;\n}\n.formula-builder .formula-line .add-tok:hover { color: var(--accent); border-color: var(--accent); }\n.formula-builder .formula-foot {\n  display: flex; align-items: center; gap: 12px;\n  padding: 8px 14px;\n  border-top: 1px solid var(--rule);\n  background: var(--bg-elev);\n  font-size: 11px;\n  color: var(--ink-3);\n  font-family: var(--mono);\n  font-feature-settings: 'tnum';\n}\n.formula-builder .formula-foot .btn {\n  padding: 4px 10px;\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  background: var(--bg);\n  color: var(--ink-2);\n  font-family: var(--sans);\n  font-size: 11px;\n  cursor: pointer;\n}\n.formula-builder .formula-foot .btn:hover { background: var(--bg-sunk); }\n.formula-builder .formula-foot .res { margin-left: auto; }\n.formula-builder .formula-foot .res b {\n  color: var(--ink); font-weight: 500;\n  font-size: 12px;\n}\n\n/* sources table */\n.src-table {\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n  overflow: hidden;\n}\n.src-table .h, .src-table .r {\n  display: grid;\n  grid-template-columns: 28px 90px 70px 1fr 130px 30px;\n  align-items: center;\n  height: 32px;\n}\n.src-table .h {\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule);\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3);\n}\n.src-table .h > div, .src-table .r > div {\n  padding: 0 10px; height: 100%; display: flex; align-items: center;\n  border-right: 1px solid var(--rule-soft);\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.src-table .h > div:last-child, .src-table .r > div:last-child { border-right: 0; }\n.src-table .h .n, .src-table .r .n { justify-content: flex-end; }\n.src-table .r {\n  border-bottom: 1px solid var(--rule-soft);\n  font-size: 12px;\n}\n.src-table .r:last-child { border-bottom: 0; }\n.src-table .r:hover { background: var(--bg-sunk); }\n.src-table .r .file {\n  font-family: var(--mono); font-size: 11.5px; color: var(--accent); font-weight: 500;\n  font-feature-settings: 'tnum';\n}\n.src-table .r .cell {\n  font-family: var(--mono); font-size: 11.5px; color: var(--ink);\n}\n.src-table .r .label { color: var(--ink-2); }\n.src-table .r .v { font-family: var(--mono); color: var(--ink); font-feature-settings: 'tnum'; }\n.src-table .r .x { color: var(--ink-4); cursor: pointer; }\n.src-table .r .x:hover { color: var(--diff); }\n.src-table .add-row {\n  display: flex; align-items: center; justify-content: center;\n  height: 30px;\n  border-top: 1px dashed var(--rule);\n  background: var(--bg-elev);\n  color: var(--ink-3); font-size: 11px;\n  cursor: pointer;\n}\n.src-table .add-row:hover { color: var(--accent); }\n\n/* master mapping */\n.master-map {\n  border: 1px solid var(--rule);\n  border-left: 3px solid var(--accent);\n  border-radius: 3px;\n  padding: 12px 14px;\n  background: var(--bg-elev);\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n}\n.master-map .field {\n  display: flex; flex-direction: column; gap: 4px;\n}\n.master-map .lbl {\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em; color: var(--ink-4);\n}\n.master-map .v {\n  font-family: var(--mono); font-size: 12.5px; color: var(--ink);\n  font-feature-settings: 'tnum';\n}\n\n/* validation */\n.valid-list {\n  display: flex; flex-direction: column;\n  gap: 1px;\n  background: var(--rule-soft);\n  border: 1px solid var(--rule);\n  border-radius: 3px;\n}\n.valid-rule {\n  display: flex; align-items: center; gap: 12px;\n  padding: 8px 12px;\n  background: var(--bg);\n  font-size: 11.5px;\n}\n.valid-rule .dot {\n  width: 8px; height: 8px; border-radius: 50%;\n  background: var(--match);\n  flex: 0 0 8px;\n}\n.valid-rule.bad .dot { background: var(--diff); }\n.valid-rule .lbl { color: var(--ink); flex: 0 0 auto; }\n.valid-rule .msg {\n  margin-left: auto;\n  font-family: var(--mono); font-size: 11px; color: var(--ink-3);\n  font-feature-settings: 'tnum';\n}\n.valid-rule.bad .msg { color: var(--diff); }\n\n/* ─── Right pane: live preview ─── */\n.preview-pane {\n  border-left: 1px solid var(--rule);\n  background: var(--bg-elev);\n  overflow: auto;\n  display: flex; flex-direction: column;\n}\n.preview-pane .ph {\n  position: sticky; top: 0;\n  display: flex; align-items: baseline;\n  padding: 10px 14px;\n  background: var(--bg-elev);\n  border-bottom: 1px solid var(--rule);\n  z-index: 2;\n}\n.preview-pane .ph .t {\n  font-size: 10.5px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-3); font-weight: 600;\n}\n.preview-pane .ph .live {\n  margin-left: auto;\n  font-family: var(--mono); font-size: 10px; color: var(--match);\n  font-feature-settings: 'tnum';\n}\n.preview-pane .ph .live .dot {\n  display: inline-block; width: 6px; height: 6px; border-radius: 50%;\n  background: var(--match); margin-right: 4px;\n  vertical-align: middle;\n  animation: pulse 2s ease-in-out infinite;\n}\n@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .35; } }\n\n.preview-pane .pr-block {\n  padding: 14px 14px;\n  border-bottom: 1px solid var(--rule-soft);\n}\n.preview-pane .pr-block .h {\n  font-size: 10px; text-transform: uppercase; letter-spacing: .08em;\n  color: var(--ink-4); font-weight: 600;\n  margin-bottom: 6px;\n}\n.preview-pane .pr-cluster {\n  display: grid; grid-template-columns: 60px 1fr auto;\n  align-items: center;\n  padding: 5px 0;\n  border-bottom: 1px solid var(--rule-soft);\n  gap: 8px;\n}\n.preview-pane .pr-cluster:last-child { border-bottom: 0; }\n.preview-pane .pr-cluster .code {\n  font-family: var(--mono); font-size: 11px; font-weight: 600;\n  color: var(--ink); letter-spacing: .04em;\n}\n.preview-pane .pr-cluster .name {\n  font-size: 11.5px; color: var(--ink-2);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.preview-pane .pr-cluster .v {\n  font-family: var(--mono); font-size: 12px;\n  color: var(--ink); font-feature-settings: 'tnum';\n}\n.preview-pane .pr-cluster.curr {\n  background: color-mix(in oklab, var(--accent) 6%, transparent);\n}\n\n.preview-pane .impact {\n  font-size: 11.5px; color: var(--ink-2);\n  line-height: 1.5;\n}\n.preview-pane .impact b { color: var(--ink); font-weight: 500; }\n\n/* ─── Cell preview popover ─── */\n.cell-pop {\n  position: fixed;\n  z-index: 200;\n  width: 380px;\n  background: var(--bg-elev);\n  border: 1px solid var(--rule);\n  border-radius: 4px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, .14), 0 2px 8px rgba(0, 0, 0, .08);\n  font-family: var(--mono);\n  font-size: 11px;\n  pointer-events: none;\n  animation: cpFade .12s ease-out;\n}\n@keyframes cpFade {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.cell-pop .cph {\n  display: flex; align-items: baseline; gap: 6px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--rule);\n  background: var(--bg);\n  border-radius: 4px 4px 0 0;\n  font-feature-settings: 'tnum';\n}\n.cell-pop .cph .ftag {\n  color: var(--accent); font-weight: 600;\n  font-size: 11px;\n}\n.cell-pop .cph .sheet {\n  color: var(--ink-4); font-size: 10.5px;\n}\n.cell-pop .cph .cell {\n  margin-left: 4px;\n  color: var(--ink); font-weight: 500;\n  padding: 1px 5px;\n  background: color-mix(in oklab, var(--accent) 12%, transparent);\n  border-radius: 2px;\n  font-size: 11px;\n}\n.cell-pop .cph .lbl {\n  margin-left: auto;\n  color: var(--ink-3);\n  font-family: var(--sans);\n  font-size: 10.5px;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n.cell-pop .cgrid {\n  width: 100%;\n  border-collapse: collapse;\n  font-feature-settings: 'tnum';\n}\n.cell-pop .cgrid td {\n  padding: 4px 8px;\n  border-right: 1px solid var(--rule-soft);\n  border-bottom: 1px solid var(--rule-soft);\n  font-size: 10.5px;\n  color: var(--ink-2);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px;\n}\n.cell-pop .cgrid td:last-child { border-right: 0; }\n.cell-pop .cgrid tr:last-child td { border-bottom: 0; }\n.cell-pop .cgrid tr.h td {\n  background: var(--bg);\n  color: var(--ink-4);\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: none;\n}\n.cell-pop .cgrid td.rh {\n  background: var(--bg);\n  color: var(--ink-4);\n  font-size: 10px;\n  text-align: right;\n  width: 30px;\n}\n.cell-pop .cgrid td.n { text-align: right; }\n.cell-pop .cgrid td.hl {\n  background: color-mix(in oklab, var(--accent) 14%, var(--bg-elev));\n  color: var(--ink);\n  font-weight: 600;\n  outline: 1px solid var(--accent);\n  outline-offset: -1px;\n  position: relative; z-index: 1;\n}\n.cell-pop .cpf {\n  padding: 7px 12px;\n  border-top: 1px solid var(--rule);\n  font-size: 10.5px;\n  color: var(--ink-3);\n  font-family: var(--sans);\n  background: var(--bg);\n  border-radius: 0 0 4px 4px;\n}\n\n/* ref token (formula referring to another row) */\n.formula-builder .formula-line .tok.ref .file {\n  color: var(--ink-3);\n  font-style: italic;\n}\n.formula-builder .formula-line .tok.ref {\n  background: var(--bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
